export const saveTypes: { name: string; extension: string; fileType: string; mimeType: string }[] = [
    {
        name: 'Save as .txt',
        extension: '.txt',
        fileType: 'txt',
        mimeType: 'text/plain',
    },
    {
        name: 'Save as .html',
        extension: '.html',
        fileType: 'html',
        mimeType: 'text/html',
    },
    {
        name: 'Save as .json',
        extension: '.json',
        fileType: 'json',
        mimeType: 'application/json',
    },
    {
        name: 'Save as .csv',
        extension: '.csv',
        fileType: 'csv',
        mimeType: 'text/csv',
    },
    {
        name: 'Save as .xml',
        extension: '.xml',
        fileType: 'xml',
        mimeType: 'application/xml',
    },
    {
        name: 'Save as .yaml',
        extension: '.yaml',
        fileType: 'yaml',
        mimeType: 'text/yaml',
    },
    {
        name: 'Save as .pdf',
        extension: '.pdf',
        fileType: 'pdf',
        mimeType: 'application/pdf',
    },
    {
        name: 'Save as .docx',
        extension: '.docx',
        fileType: 'docx',
        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    },
    {
        name: 'Save as .png',
        extension: '.png',
        fileType: 'png',
        mimeType: 'image/png',
    },
    {
        name: 'Save as .jpg',
        extension: '.jpg',
        fileType: 'jpg',
        mimeType: 'image/jpeg',
    },
    {
        name: 'Save as .webp',
        extension: '.webp',
        fileType: 'webp',
        mimeType: 'image/webp',
    },
];
